import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';
import { CallStore } from '../../app/calls/CallStore';
import { JsonDocument } from '../../app/services/json-api/JsonDocument';
import { RegisteredCall } from '../../app/calls/RegisteredCall';
import { Resource } from '../../app/services/json-api/Resource';
import { CallType } from '../../app/calls/CallType';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

interface HistoryViewProps {
    disableCallBack?: boolean;
    callStore?: CallStore;
    onCallBack: (previousCall: Resource<RegisteredCall>) => void;
}

const renderCallType = (call: Resource<RegisteredCall>): React.ReactElement => {
    if (call.getAttribute('call_type') === CallType.OUTGOING_STRING) {
        return <span className="call-type-outgoing">Uitgaand</span>
    }


    if (call.getAttribute('call_type') === CallType.INCOMING_STRING && !call.getAttribute('is_missed_call')) {
        return <span className="call-type-incoming">Inkomend</span>
    }

    return <span className="call-type-missed">Gemiste oproep</span>
}

const renderHistory = (
    onCallBack: (previousCall: Resource<RegisteredCall>) => void,
    disableCallBack: boolean | undefined,
    history?: JsonDocument<RegisteredCall>,
): React.ReactNode => {
    if (!history || history.isEmpty()) {
        return <div className="col-span-5">Geen geschiedenis</div>;
    }

    return history.getResources().map((registeredCall: Resource<RegisteredCall>) => (
        <>
            <div className="col-span-2">
                <div>{registeredCall.getAttribute('phone_number')}</div>
                <div>{renderCallType(registeredCall)}</div>
            </div>
            <div className="col-span-2">{registeredCall.getAttribute('created_at')}</div>
            <div className="col-span-1"><button
                disabled={disableCallBack}
                className="btn small btn-darker-transparent"
                onClick={() => {
                    onCallBack(registeredCall);
                }}
            >
                <FontAwesomeIcon icon={faPhone} />
            </button></div>
        </>
    ));
};

const HistoryViewProps = React.forwardRef<HTMLDivElement, HistoryViewProps>((
    {
        disableCallBack,
        callStore,
        onCallBack
    },
    ref
): React.ReactElement => {
    // const [history, setHistory] = useState<JsonDocument<RegisteredCall>>();

    useEffect(() => {
        callStore!.getHistory();
    }, [callStore])

    useEffect(() => {
        callStore!.unseen = 0;
    }, [callStore]);

    return (
        <div
            className="history-container"
            ref={ref}
        >
            <div className="grid grid-cols-5 history-list gap-2">
                <div className="my-2 history-title col-span-2"><strong>Van</strong></div>
                <div className="my-2 history-title col-span-2"><strong>Datum</strong></div>
                <div className="my-2 history-title col-span-1"><strong>Acties</strong></div>
            </div>
            <div className="grid grid-cols-5 history-list gap-2">
                {renderHistory( onCallBack, disableCallBack, callStore!.history)}
            </div>
        </div>
    );
});

HistoryViewProps.displayName = 'HistoryViewProps';

export default inject('callStore')(observer(HistoryViewProps));
